import React from 'react';
import { withTranslation } from 'react-i18next';
import { RCV } from '../RCV';
import { SocialBar } from '../SocialBar';
import { SocialBarIcons, QuestionBasicBlock, AnswerBasicBlock } from './style';
import { connect } from 'react-redux';
import LinesEllipsis from 'react-lines-ellipsis';
import wixService from '../../../../../../services/wixService';

class BasicView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { questions, design, styleParams, settings, locale } = this.props;
    const questionHtmlTag =
      styleParams &&
      styleParams.fonts &&
      styleParams.fonts.questionTextFont &&
      styleParams.fonts.questionTextFont.htmlTag
        ? styleParams.fonts.questionTextFont.htmlTag
        : 'h3';
    const isMobile = wixService.isMobile();
    const arrQuestions = questions || [];
    const parentClassAnswer = 'rcvForAnswer';
    const parentClassQuestion = 'rcvForQuestion';
    // console.log({isRTL}, settings.textAlignment);
    return (
      <>
        {arrQuestions
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map((faq, index) => {
            const itemIndex = index + 1;
            // const questionTitle = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. \nIt has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.";
            const questionTitle = faq.question;
            const questionAnswer = faq.answer;
            const questionId = faq.id || itemIndex;
            const shareLink = faq.shareLink || '';
            const categoryId = faq.categoryId;
            const question_order = faq.sortOrder;
            return (
              <div
                className="question-container"
                itemType="https://schema.org/Question"
                itemScope
              >
                <div className={'question-title-box ' + parentClassQuestion}>
                  <div className="question-title" data-itemProp="name">
                    <QuestionBasicBlock
                      styleParams={styleParams}
                      design={design}
                      settings={settings}
                    >
                      <LinesEllipsis
                        text={questionTitle}
                        maxLine={7}
                        ellipsis="..."
                        trimRight={true}
                        component={questionHtmlTag}
                        basedOn="letters"
                      />
                    </QuestionBasicBlock>
                  </div>
                </div>
                <div className="answer" data-itemProp="acceptedAnswer">
                  <div className={'questionAnswer ' + parentClassAnswer}>
                    <AnswerBasicBlock
                      styleParams={styleParams}
                      design={design}
                      settings={settings}
                    >
                      <RCV
                        locale={locale}
                        content={questionAnswer}
                        isMobile={isMobile}
                        parentClass={parentClassAnswer}
                        textAlignment={settings.textAlignment}
                        usage="BasicView"
                      />
                    </AnswerBasicBlock>
                  </div>
                  <SocialBarIcons design={design} styleParams={styleParams}>
                    <SocialBar
                      itemId={questionId}
                      categoryId={categoryId}
                      question_order={question_order}
                      isRTL={settings.isRTL}
                      shareLink={shareLink}
                    />
                  </SocialBarIcons>
                </div>
              </div>
            );
          })}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(BasicView));
